import React, { useState } from "react";
import { getAutoCity } from '../../Services/API';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';

const FlightSearch = () => {
    const [sections, setSections] = useState([]);
    const [errors, setErrors] = useState({});
    const [departureQuery, setDepartureQuery] = useState("");
    const [departureSuggestions, setDepartureSuggestions] = useState([]);
    const [arrivalQuery, setArrivalQuery] = useState("");
    const [arrivalSuggestions, setArrivalSuggestions] = useState([]);
    const isMultiCityActive = sections.length > 0;

    const navigate = useNavigate();
    const [onwardDate, setOnwardDate] = useState(null);
    const [returnDate, setReturnDate] = useState(null);

    const addSection = () => {
        setSections((prev) => {
            if (prev.length >= 3) {
                alert("You can add only up to 3 sections.");
                return prev;
            }

            // Get arrival of last section if available, otherwise leave empty
            const lastArrival = prev.length > 0 && prev[prev.length - 1].arrival
                ? prev[prev.length - 1].arrival
                : "";

            return [...prev, { departure: lastArrival, arrival: "", date: "" }];
        });
    };

    const removeSection = (index) => {
        setSections((prev) => prev.filter((_, i) => i !== index));
    };

    const handleChange = (e, index = null, field = null, fieldValue = null) => {
        if (e) {
            //  Handle normal input/select change for flightlist
            const { name, value, type, checked } = e.target;
            setFlightlist((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value,
                
            }));
        }
        else if (index !== null && field !== null) {
            //  Handle multi-section (multi-city) change
            setSections((prev) => {
                const updated = [...prev];
                updated[index][field] = fieldValue;
                return updated;
            });
        }
    };



    // --- HANDLE DEPARTURE CHANGE ---
    const handleDepartureChange = async (e) => {
        const value = e.target.value;
        setDepartureQuery(value);
        if (value.length >= 2) {
            const data = await getAutoCity(value);
            setDepartureSuggestions(data);
        } else {
            setDepartureSuggestions([]);
        }
    };

    // --- HANDLE ARRIVAL CHANGE ---
    const handleArrivalChange = async (e) => {
        const value = e.target.value;
        setArrivalQuery(value);
        if (value.length >= 2) {
            const data = await getAutoCity(value);
            setArrivalSuggestions(data);
        } else {
            setArrivalSuggestions([]);
        }
    };

    // --- SELECT CITY ---
    const selectDeparture = (city) => {
        const fullName = `${city.cityName} (${city.autoCompleteCode}) - ${city.countryName}`;

        setFlightlist((prev) => ({
            ...prev,
            departureQuery: fullName,
        }));

        setDepartureSuggestions([]);
    };

    const selectArrival = (city) => {
        const fullName = `${city.cityName} (${city.autoCompleteCode}) - ${city.countryName}`;

        setFlightlist((prev) => ({
            ...prev,
            arrivalQuery: fullName,
        }));

        setArrivalSuggestions([]);
    };



    // get City


    const swapDestination = (index) => {
        setSections((prev) => {
            if (!prev[index]) return prev; // guard
            const updated = [...prev];
            const { departure, arrival } = updated[index];
            updated[index] = { ...updated[index], departure: arrival, arrival: departure };
            return updated;
        });
    };
   
const swapMainDestination = (e) => {
    e.preventDefault();

    setFlightlist((prev) => ({
        ...prev,
        departureQuery: prev.arrivalQuery,
        arrivalQuery: prev.departureQuery,
    }));
};

    const [flightlist, setFlightlist] = useState({
        departureQuery: "",
        arrivalQuery: "",
        onwardDate: "",
        returnDate: "",
        adult: "1",
        child: "",
        infant: "",
        selClass: "ECONOMY",
        airlinePreference: "",
        timePreference: "",
        typeFare: "Corporate Fare",
        nonStop: true,
    });

    const handleSearch = (e) => {
        e.preventDefault();
        let newErrors = {};

        const { departureQuery, arrivalQuery, onwardDate } = flightlist;

  if (!departureQuery.trim()) newErrors.departure = "Please select a Departure City";
  if (!arrivalQuery.trim()) newErrors.arrival = "Please select an Arrival City";
  if (!onwardDate.trim()) newErrors.onwardDate = "Please select a Departure Date";

  setErrors(newErrors);
  if (Object.keys(newErrors).length !== 0) return;

  // save for refresh
  sessionStorage.setItem("searchData", JSON.stringify(flightlist));

  // build url
  const query = new URLSearchParams(flightlist).toString();

  navigate(`/flight/result?${query}`, {
    state: flightlist,
  });
};


    return (
        <>
            <form onSubmit={handleSearch}>
                <section className='flight_top_banner'>
                    <div className='container'>
                        <div className='col-md-12 col-lg-12'>
                            <div className='Search_form'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='d-flex'>
                                        <div className="travel_mode">
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="travelType"
                                                    id="BusinessTravel"
                                                />
                                                <label className="form-check-label" htmlFor="BusinessTravel">
                                                    Business Travel
                                                </label>
                                            </div>
                                        </div>

                                        <div className="travel_mode">
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="travelType"
                                                    id="PersonalTravel"
                                                />
                                                <label className="form-check-label" htmlFor="PersonalTravel">
                                                    Personal Travel
                                                </label>
                                            </div>
                                        </div>

                                        <div className="travel_mode">
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="travelType"
                                                    id="GuestTravel"
                                                />
                                                <label className="form-check-label" htmlFor="GuestTravel">
                                                    Guest Travel
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 col-lg-12'>
                                    <div className='top_main_taber'>
                                        <div className="left_taber">
                                            {/* Departure City */}
                                            <div className="input_fm_sr" style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="departureQuery"
                                                    placeholder="Departure City.."
                                                    value={flightlist.departureQuery}
                                                    onChange={(e) => {
                                                        handleChange(e);           // updates state
                                                        handleDepartureChange(e);  // fetches suggestions
                                                    }}
                                                />

                                                {/* Suggestion List */}
                                                {departureSuggestions.length > 0 && (
                                                    <ul>
                                                        {departureSuggestions.map((city, index) => (
                                                            <li key={index} onClick={() => selectDeparture(city)}>
                                                                {city.cityName} ({city.autoCompleteCode}) - {city.countryName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {errors.departure && <p className="error">{errors.departure}</p>}

                                                <a href="#!" className="swipers" onClick={swapMainDestination}>
                                                    <img src="/assets/images/swipe.png" alt="icon" />
                                                </a>
                                            </div>

                                            {/* Arrival City */}
                                            <div className="input_fm_sr" style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="arrivalQuery"
                                                    placeholder="Arrival City.."
                                                    value={flightlist.arrivalQuery}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        handleArrivalChange(e);
                                                    }}
                                                />

                                                {arrivalSuggestions.length > 0 && (
                                                    <ul>
                                                        {arrivalSuggestions.map((city, index) => (
                                                            <li key={index} onClick={() => selectArrival(city)}>
                                                                {city.cityName} ({city.autoCompleteCode}) - {city.countryName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {errors.arrival && <p className="error">{errors.arrival}</p>}
                                            </div>

                                            {/* Dates */}
                                            <div className="input_fm_sr let_date ort">
                                                {/* Onward Date */}
                                                <div className="input_fm_sr let_date ort">
                                                    {/* Onward Date */}
                                                    <div className="input_fm_sr">
                                                        <DatePicker
                                                            selected={flightlist.onwardDate ? new Date(flightlist.onwardDate) : null}
                                                            onChange={(date) => {
                                                                const formatted = date.toLocaleDateString("en-CA");
                                                                setFlightlist((prev) => ({
                                                                    ...prev,
                                                                    onwardDate: formatted, //  Update flightlist
                                                                }));
                                                            }}
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Departure date"
                                                            minDate={new Date()}
                                                            popperPlacement="bottom-start"
                                                        />
                                                    </div>
                                                    {errors.onwardDate && <p className="error">{errors.onwardDate}</p>}

                                                    {/* Return Date */}
                                                    <div className="input_fm_sr">
                                                        <DatePicker
                                                            selected={flightlist.returnDate ? new Date(flightlist.returnDate) : null}
                                                            onChange={(date) => {
                                                                const formatted = date.toLocaleDateString("en-CA");
                                                                setFlightlist((prev) => ({
                                                                    ...prev,
                                                                    returnDate: formatted, //  Update flightlist
                                                                }));
                                                            }}
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Return date"
                                                            minDate={flightlist.onwardDate ? new Date(flightlist.onwardDate) : new Date()}
                                                            maxDate={
                                                                flightlist.onwardDate
                                                                    ? new Date(
                                                                        new Date(flightlist.onwardDate).getFullYear() + 1,
                                                                        new Date(flightlist.onwardDate).getMonth(),
                                                                        new Date(flightlist.onwardDate).getDate()
                                                                    )
                                                                    : new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                                                            }
                                                            popperPlacement="bottom-start"
                                                            disabled={isMultiCityActive}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input_fm_sbc">
                                            <div className="input_fm_sr">
                                                {/* Passenger Dropdown */}
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    {Number(flightlist.adult) + Number(flightlist.child) + Number(flightlist.infant)} Total Pax
                                                </button>

                                                <div className="dropdown-menu p-3 dropdown_passenger_info">
                                                    <div className="passengers-types">
                                                        {/* Adults */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Adult</p>
                                                                <span>12+ yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="adult"
                                                                value={flightlist.adult}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(9)].map((_, i) => (
                                                                    <option key={i} value={i}>
                                                                        {i}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Children */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Children</p>
                                                                <span>2 - 12 yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="child"
                                                                value={flightlist.child}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(10)].map((_, i) => (
                                                                    <option key={i} value={i}>
                                                                        {i}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Infants */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Infant</p>
                                                                <span>Less than 2 yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="infant"
                                                                value={flightlist.infant}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(10)].map((_, i) => (
                                                                    <option key={i} value={i}>
                                                                        {i}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Class Dropdown */}
                                            <div className="input_fm_sr">
                                                <select
                                                    className="form-select form-select-solid"
                                                    name="selClass"
                                                    value={flightlist.selClass}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="ECONOMY">Economy</option>
                                                    <option value="PREMIUM">Premium Economy</option>
                                                    <option value="BUSINESS">Business</option>
                                                    <option value="FIRST">First Class</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="col-md-12 col-lg-12 Add_multiple">
                                    {sections.map((section, index) => (
                                        <div className="d-flex-main" key={index}>
                                            <div className="left_taber">
                                                {/* Multi Departure City */}
                                                <div className="input_fm_sr" style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Departure City.."
                                                        value={section.multicitydeparture || ""}
                                                        onChange={(e) =>
                                                            handleChange(null, index, "departure", e.target.value)
                                                        }
                                                    />

                                                    <a
                                                        href="#!"
                                                        className="swipers"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            swapDestination(index);
                                                        }}
                                                    >
                                                        <img src="/assets/images/swipe.png" alt="icon" />
                                                    </a>
                                                </div>

                                                {/* Multi Arrival City */}
                                                <div className="input_fm_sr" style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Arrival City.."
                                                        value={section.multicityarrival || ""}
                                                        onChange={(e) =>
                                                            handleChange(null, index, "arrival", e.target.value)
                                                        }
                                                    />
                                                </div>

                                                {/* Date Picker */}
                                                <div className="input_fm_sr">
                                                    <DatePicker
                                                        selected={section.date ? new Date(section.date) : null}
                                                        onChange={(date) =>
                                                            handleChange(
                                                                null,
                                                                index,
                                                                "date",
                                                                date ? date.toISOString().split("T")[0] : ""
                                                            )
                                                        }
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select date"
                                                        minDate={new Date()}
                                                    />
                                                </div>
                                            </div>

                                            {/* Remove Button */}
                                            <div className="click_remove">
                                                <a
                                                    href="#!"
                                                    className="deleteFlight minus-signs"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        removeSection(index);
                                                    }}
                                                >
                                                    ×
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <div className='d-flex-main'>
                                    <div className="special_view_left">
                                        {/* Airline Preference */}
                                        <div className="input_fm_sr">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="airlinePreference"
                                                value={flightlist.airlinePreference}
                                                onChange={handleChange}
                                                placeholder="Airline Preference"
                                            />
                                        </div>

                                        {/* Time Preference */}
                                        <div className="input_fm_sr">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="timePreference"
                                                value={flightlist.timePreference}
                                                onChange={handleChange}
                                                placeholder="Departure Time Preference"
                                            />
                                        </div>

                                        {/* Type Fare */}
                                        <div className="input_fm_sr">
                                            <select
                                                className="form-select form-select-solid"
                                                name="typeFare"
                                                value={flightlist.typeFare}
                                                onChange={handleChange}>
                                                <option value="">TYPE FARES</option>
                                                <option value="Corporate Fare">Corporate Fare</option>
                                                <option value="Special Fare">Special Fare</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='special_view_right'>
                                        <button className='btn btn-primary-search' type='submit'>Search </button>
                                        <button className='btn btn-primary-add' type="button" onClick={addSection} disabled={sections.length >= 2} >Add <i className='fa fa-plus'></i></button>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className="d-flex-stops">
                                        <div className="form-check form-check-custom form-check-solid mb-2 mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="NonStop"
                                                name="nonStop"
                                                checked={flightlist.nonStop}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="NonStop">
                                                Non Stop Flights Only
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>

        </>

    );
};
export default FlightSearch;
